import AdminInput from "../../components/AdminInput";
import { useTranslation } from "react-i18next";

const BillingInformation = ({
    loading,
    data
}) => {
    const { t } = useTranslation();
    return (
        <div className="card-body px-4">
            <h5 className="account-section-title py-2">Billing Information</h5>
            <hr className="hr-grey-account" />
            <div className="row d-flex align-items-start justify-content-between">
                <div className="col-12 col-lg-10">
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-5 col-lg-3">
                            <p className="account-text-label mb-0">
                                Contact Name
                            </p>
                        </div>
                        <div className="col-7 col-lg-9">
                            <p className="account-text-value mb-0">
                                {data?.businessDetail?.billingInformation?.name}
                            </p>
                        </div>
                    </div>
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-5 col-lg-3">
                            <p className="account-text-label mb-0">
                                Phone Number
                            </p>
                        </div>
                        <div className="col-7 col-lg-9">
                            <p className="account-text-value mb-0">
                                {`(${data?.businessDetail?.billingInformation?.prefix_number}) ${data?.businessDetail?.billingInformation?.phone}`}
                            </p>
                        </div>
                    </div>
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-5 col-lg-3">
                            <p className="account-text-label mb-0">
                                Country
                            </p>
                        </div>
                        <div className="col-7 col-lg-9">
                            <p className="account-text-value mb-0">
                                {data?.businessDetail?.billingInformation?.country}
                            </p>
                        </div>
                    </div>
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-5 col-lg-3">
                            <p className="account-text-label mb-0">
                                Postal Code
                            </p>
                        </div>
                        <div className="col-7 col-lg-9">
                            <p className="account-text-value mb-0">
                                {data?.businessDetail?.billingInformation?.postal_code}
                            </p>
                        </div>
                    </div>
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-5 col-lg-3">
                            <p className="account-text-label mb-0">
                                City
                            </p>
                        </div>
                        <div className="col-7 col-lg-9">
                            <p className="account-text-value mb-0">
                                {data?.businessDetail?.billingInformation?.city}
                            </p>
                        </div>
                    </div>
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-5 col-lg-3">
                            <p className="account-text-label mb-0">
                                Billing Address
                            </p>
                        </div>
                        <div className="col-7 col-lg-9">
                            <p className="account-text-value mb-0">
                                {data?.businessDetail?.billingInformation?.address}
                            </p>
                        </div>
                    </div>
                </div>
                {
                    false && (
                        <div className="col-12 col-lg-2 d-flex align-items-start justify-content-end">
                            <button
                                type="button"
                                className="btn btn-edit-account px-2 py-2 mt-2 mt-lg-0"
                                onClick={() => {}}
                            >
                                {t("myPage.accountInformation.subMenu.billingInformation.button")}
                            </button>
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default BillingInformation;
